import axios from 'axios';
import cookie from "react-cookies";
import {sessionSecret} from "../../env.json";
import { Encryptor } from "../../components/global/encryptor";
import moment from "moment";
import OneSignal from 'react-onesignal';

const { encrypt, decrypt } = Encryptor(sessionSecret);

//Agent Signup State Setup --->
export const getTempState = form => {
    const userCookie = cookie.load('ibAgentTemp');
    if(!userCookie) return false;
    const params = JSON.parse(decrypt(userCookie))

    if(form === 'bool') return !!params.token;
    if(!!params[form]) return params[form];
    else return params
}

export const setTempState = params => {
    if(!params){
        cookie.remove('ibAgentTemp', { path: '/' });
    }else{
        const encryptedData = encrypt(JSON.stringify(params));
        let cookieOptions = { path:'/',secure:true };
        cookie.save('ibAgentTemp', encryptedData, cookieOptions);
    }
}

//Agent Login State Setup --->
export const getAuthState = form => {
    const userCookie = cookie.load('ibAgent');
    if(!userCookie) return false;
    const params = JSON.parse(decrypt(userCookie))

    // Check for 5 minutes before expiry 
    if(moment(params.expiresOn).subtract(5,'minutes').diff(moment()) < 0) return 'Expired'
    
    if(form === 'bool') return !!params.token;
    if(!!params[form]) return params[form]
    else return params
}

export const setAuthState = (authParams, isRemember) => {
    if(!authParams){
        OneSignal.removeExternalUserId()
        // Task 6: clears the "already shown this session" guard for the
        // one-time expiry modal (global/subscriptionBanner.js,
        // EXPIRED_MODAL_SESSION_KEY - same literal, kept in sync here) so
        // a different account logging in on the same browser tab after
        // this one logs out gets its own first-login notice, rather than
        // inheriting whatever the previous account already dismissed.
        sessionStorage.removeItem('ib_expired_modal_shown');
        return cookie.remove('ibAgent', { path: '/' });
    }
    //Encrypt Data
    const encryptedData = encrypt(JSON.stringify(authParams));
    //Set 30days Cookie 
    let cookieOptions = !isRemember ? { path : '/', secure : true } : { path : '/', maxAge : 2592000, secure : true };
    cookie.save('ibAgent', encryptedData, cookieOptions)
}

const checkExcludedPath = () => {
    const excludedPaths = ['setup','signup','signin','forgot-password','verify/','set-password'];
    let check = true
    for (const path of excludedPaths){
        if(window.location.pathname.includes(path)){
             check = false;
        }
    }
    return check;
}
   
export const setAgentRefreshedCookie = async (config) => {
    const safeToUpdate = checkExcludedPath();
    
    if( !safeToUpdate || !config ) return;
    try {
        const { data : updatedCookie } = await axios.get('/api/agent/getAgentUpdatedToken', config);
        if(!updatedCookie) throw 'Authentication failed';
        //  Convert & Set Cookie Age (1day = 86400 sec)
        const maxAge = ( moment( updatedCookie.expiresOn ).diff( moment(), 'days') + 1 ) * 86400;

        //Encrypt Data
        const encryptedData = encrypt(JSON.stringify(updatedCookie));

        let cookieOptions = maxAge <= 86400 ? { path : '/', secure : true } : { path : '/', maxAge : maxAge, secure : true };
        cookie.save('ibAgent', encryptedData, cookieOptions);
    } catch (err) {
        throw new Error(err.message || 'Authentication failed');
    }
}

